import { I18n } from "@assets/strings";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import subscriberIcon from "@assets/images/subscriberIcon.svg";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Wallet } from "@domain/wallet/wallet";
import { Primary } from "@ui/components/containers/primary";
interface TransactionsListProps extends React.HTMLAttributes<HTMLDivElement> {
	transactions: Wallet[];
}

export const TransactionsList: React.FC<TransactionsListProps> = ({ transactions }) => {
	const currentProfile = useCurrentProfile();
	return (
		<>
			{transactions.map((item) => (
				<StyledOperation key={item.id}>
					<StyledLeftContainer>
						<StyledIcon>
							<img src={subscriberIcon} />
						</StyledIcon>
						<ContainerItem>
							<StyledOperationType>
								{item.type === "CASHOUT"
									? I18n.t("shareroom.dashboard.transactions.table.cashout.title")
									: I18n.t(`shareroom.dashboard.transactions.table.subscription_mode.${item.subscriptionMode}`)}
							</StyledOperationType>
							<StyledOperationAuthor>
								{item.issuerPrimaryName} {item.issuerSecondaryName}
							</StyledOperationAuthor>
							<StyledOperationDate>{moment(item.date).format("LLL")}</StyledOperationDate>
						</ContainerItem>
					</StyledLeftContainer>
					<StyledRightContainer>
						<StyledWalletType>{item.mode}</StyledWalletType>
						<StyledPhoneNumber>{item.issuerNumber}</StyledPhoneNumber>
						{item.type === "CASHOUT" ? (
							<StyledOperationAmountWithdrawn>
								- {item.amountIUC} {currentProfile?.currency}
							</StyledOperationAmountWithdrawn>
						) : (
							<StyledOperationAmountSubscription>
								+ {item.amountIUC} {currentProfile?.currency}
							</StyledOperationAmountSubscription>
						)}
					</StyledRightContainer>
				</StyledOperation>
			))}
		</>
	);
};

const StyledOperation = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;
const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: row;
	line-height: 16px;
	margin-bottom: 18px;
`;
const ContainerItem = styled.div`
	flex-direction: column;
	margin-left: 10px;
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	text-align: -webkit-right;
	line-height: 16px;
`;
const StyledOperationType = styled(Primary)`
	font-weight: 700;
	font-size: 12px;
	/* line-height: 26px; */
`;
const StyledOperationAuthor = styled.div`
	font-weight: 400;
	font-size: 10px;
	/* line-height: 13px; */
	color: #206af8;
`;
const StyledOperationDate = styled(Primary)`
	font-weight: 400;
	font-size: 8px;
	/* line-height: 10px; */
`;

const StyledWalletType = styled(Primary)`
	font-weight: 700;
	font-size: 12px;
	/* line-height: 26px; */
	/* identical to box height, or 186% */
`;

const StyledPhoneNumber = styled(Primary)`
	font-size: 10px;
	/* line-height: 13px; */
	/* identical to box height, or 186% */

	color: #fbb513;
`;

const StyledIcon = styled.div``;
const StyledOperationAmountWithdrawn = styled(Primary)`
	font-weight: 400;
	font-size: 10px;
	/* line-height: 26px; */
	color: #e83636;
`;

const StyledOperationAmountSubscription = styled(Primary)`
	font-weight: 400;
	font-size: 10px;
	/* line-height: 26px; */
	color: rgba(52, 200, 15, 0.8);
`;
